/*
 * Copyright (C) 2024 Das Land Schleswig-Holstein vertreten durch den
 * Ministerpräsidenten des Landes Schleswig-Holstein
 * Staatskanzlei
 * Abteilung Digitalisierung und zentrales IT-Management der Landesregierung
 *
 * Lizenziert unter der EUPL, Version 1.2 oder - sobald
 * diese von der Europäischen Kommission genehmigt wurden -
 * Folgeversionen der EUPL ("Lizenz");
 * Sie dürfen dieses Werk ausschließlich gemäß
 * dieser Lizenz nutzen.
 * Eine Kopie der Lizenz finden Sie hier:
 *
 * https://joinup.ec.europa.eu/collection/eupl/eupl-text-eupl-12
 *
 * Sofern nicht durch anwendbare Rechtsvorschriften
 * gefordert oder in schriftlicher Form vereinbart, wird
 * die unter der Lizenz verbreitete Software "so wie sie
 * ist", OHNE JEGLICHE GEWÄHRLEISTUNG ODER BEDINGUNGEN -
 * ausdrücklich oder stillschweigend - verbreitet.
 * Die sprachspezifischen Genehmigungen und Beschränkungen
 * unter der Lizenz sind dem Lizenztext zu entnehmen.
 */
import { KeycloakResourceService } from '@administration/keycloak-shared';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AdministrationOrganisationsEinheit } from './organisations-einheit.model';
import { AdministrationOrganisationsEinheitRepository } from './organisations-einheit.repository';

@Injectable({
  providedIn: 'root',
})
export class AdministrationOrganisationsEinheitService extends KeycloakResourceService<AdministrationOrganisationsEinheit> {
  private readonly repository = inject(AdministrationOrganisationsEinheitRepository);

  _getItemsFromKeycloak(): Observable<AdministrationOrganisationsEinheit[]> {
    return this.repository.getList();
  }

  _createInKeycloak(organisationsEinheit: AdministrationOrganisationsEinheit): Observable<AdministrationOrganisationsEinheit> {
    return this.repository.create(organisationsEinheit);
  }

  _saveInKeycloak(organisationsEinheit: AdministrationOrganisationsEinheit): Observable<AdministrationOrganisationsEinheit> {
    throw new Error('Method not implemented.');
  }

  _deleteInKeycloak(id: string): Observable<void> {
    return this.repository.delete(id);
  }
}
